export default __webpack_public_path__ + "static/media/phoneWhite.5f2290ea.svg";